<template>
  <div class="checkout-errors-container" v-if="Object.keys(errors).length > 0 && errors">
    <div class="checkout-errors-header">
      <span v-if="Object.keys(errors).length > 1" class="checkout-errors-header-text" >
        {{ t('checkout.fields.required') }}
      </span>
      <span v-else class="checkout-errors-header-text" >
        {{ t('checkout.field.required') }}
      </span>
    </div>
    <div class="checkout-errors-body">
      <span
        v-for="(errorValue, errorKey) in errors"
        :key="errorKey"
        class="checkout-errors-body-text"
        v-html="errorValue"
      >
      </span>
    </div>
    <div class="checkout-errors-footer">
      <button
        @click="$root.$emit('modal-close')"
        name="Continue"
        type="button"
        :value="t('preview.order.continue')"
        class="checkout-errors-footer-btn"
      >
        {{ t('checkout.validation.continue.ok') }}
      </button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CheckoutErrors',
  props: {
    errors: {}
  }
}
</script>

<style lang="scss" scoped>
.checkout-errors {
  &-container {
    position: relative;
    width: 100%;
    height: auto;
    display: grid;
    justify-content: center;
    justify-items: center;
    gap: 2rem;
  }
  &-header {
    display: grid;
    justify-items: center;
    align-items: center;
    &-text {
      font-size: 18px;
      font-weight: 700;
      color: #121218;
      @media screen and (max-width: 767px) {
        font-size: 15px;
        text-align: center;
      }
    }
  }
  &-body {
    width: 100%;
    display: grid;
    justify-content: center;
    padding: 1rem;
    background-color: #ffe8d9d1;
    border-radius: 10px;
    border-left: 5px solid #f27545;
    &-text {
      color: #6f3324;
      @media screen and (max-width: 767px) {
        font-size: 12px;
      }
    }
  }
  &-footer {
    position: relative;
    width: 100%;
    display: grid;
    justify-items: center;
    align-items: center;
    &-btn {
      width: 100%;
      max-width: 300px;
      padding: 0.5rem 0;
      font-size: 20px;
      font-weight: 700;
      color: #121218;
      background-color: rgb(229, 247, 239);
      border: unset;
      border-left: 5px solid #aae4aa;
      border-radius: 5px;
      &:hover {
        background-color: #aae4aa;
      }
      @media screen and (max-width: 767px) {
        font-size: 15px;
      }
    }
  }
}
</style>
